<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f mar_t20 mar_l20">
        <div class="pagetitle mar_b20">{{ $t('set.versionUpdate.title') }}</div>
      </div>
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('set.versionUpdate.version')" :required="true">
          <el-input v-model.trim="form.version" autocomplete="off" :placeholder="$t('set.versionUpdate.versionPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.versionUpdate.downloadUrl')" :required="true">
          <el-input v-model.trim="form.downloadUrl" autocomplete="off" :placeholder="$t('set.versionUpdate.downloadUrlPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.versionUpdate.forceUpdate')" :required="true">
          <el-switch v-model="form.forceUpdate" active-value="1" inactive-value="2"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('set.versionUpdate.content')" :required="true">
          <el-input type="textarea" v-model.trim="form.content" :rows="6" :placeholder="$t('set.versionUpdate.contentPh')"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getConfig, postConfig } from '@/api/set';

export default {
  data() {
    return {
      form: {
        ident: 'versionUpdate',
        version: '',
        downloadUrl: '',
        forceUpdate: '2',
        content: ''
      }
    };
  },
  created() {
    this.bus.$emit('loading', true);
    this.init();
  },
  methods: {
    async init() {
      const { data } = await getConfig({ ident: 'versionUpdate' });
      this.form = Object.assign({}, this.form, data);
      this.form.ident = 'versionUpdate';
      this.bus.$emit('loading', false);
    },
    async submitForm() {
      const { msg } = await postConfig(this.form);
      this.$baseMessage(msg, 'success');
      this.init();
    }
  }
};
</script>
